const getCurrentTime = () => {
  const hours = new Date().getHours();

  if (hours === 23) {
    return '23:00 - 00:00';
  }
  return (
    hours.toString().padStart(2, '0') +
    ':00' +
    ' - ' +
    (hours + 1).toString().padStart(2, '0') +
    ':00'
  );
};
const appointmentValues = {
  serviceDetails: [],
  date: new Date(),
  time: getCurrentTime(),
  notes: '',
  comments: '',
  isDeleted: false,
  appointmentAction: 'noAction',
  appointmentStatus: 'scheduled',
  visitType: '',
  selectedUser: {},
};

function Appointment(state = { appointmentValues }, action) {
  const { field, value } = action.payload;

  switch (action.type) {
    case 'setAppointmentValues':
      if (field === 'comments' && value?.length > 700) {
        return {
          ...state,
        };
      }
      if (field === 'notes' && value?.length > 700) {
        return {
          ...state,
        };
      }
      return {
        ...state,
        appointmentValues: {
          ...state.appointmentValues,
          [field]: value,
        },
      };

    case 'updateAppointment':
      return { ...state, appointmentValues: { ...value } };
    case 'clearAppointmentValues':
      return {
        ...state,
        appointmentValues: {
          serviceDetails: [],
          date: new Date(),
          time: getCurrentTime(),
          notes: '',
          comments: '',
          appointmentAction: 'noAction',
          appointmentStatus: 'scheduled',
          visitType: '',
          isDeleted: false,
          selectedUser: {},
        },
      };
    default:
      return state;
  }
}
export default Appointment;
